export function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-background/95 backdrop-blur supports-[backdrop-filter]:bg-background/60 border-t border-border/20">
      <div className="mx-auto px-8 py-4 flex items-center justify-center">
        <p className="text-sm text-muted-foreground">
          © {currentYear} WealthyCub — One pawprint at a time 🐻
        </p>
      </div>
    </footer>
  );
}
